import { Inline as BInline, styled } from '@bayon/commons';

export const Inline = styled(BInline)({
  marginBottom: 12,
});

export const SelectContainer = styled('div')({
  width: '100%',
});
